<template>
    <div>
        <el-dialog title="修改备注" :visible.sync="showForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="formData">
                <el-form-item label="备注内容" prop="comment">
                    <el-input type="textarea" rows="6" v-model="formData.comment" placeholder="请输入跟进内容"
                        clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showForm = false">取消</el-button>
                <el-button type="primary" @click="savelog">确定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import { validateIdNo } from "@/script/validator";

export default {
    components: {},

    filters: {

    },
    data() {
        return {
            showForm: false,
            formData: {
                taskId: '',
                handleId: '',
                comment: '',
            }
        }
    },
    methods: {
        showUpdate(taskRow) {
            this.showForm = true;
            this.formData = {
                taskId: taskRow.id,
                handleId: globalData.userInfo.id,
                comment: taskRow.content,
            }
        },
        savelog() {
            if (this.formData.comment == '') {
                this.$message.error('备注内容不能为空');
                return;
            }

            taskApi.$axioUpdateTaskContent(this.formData).then(res => {

                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showForm = false;
                    this.$parent.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            })
        }
    }
};
</script>

<style scoped></style>
  